import { Grid } from '@material-ui/core';
import ExternalEmployeesFilterComponent from "./ExternalEmployeesFilterComponent/ExternalEmployeesFilterComponent";
import ExternalEmployeesTableComponent from "./ExternalEmployeesTableComponent/ExternalEmployeesTableComponent";
import { styles, useStyles } from '../UserSearchScreenStyles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as UserSearchActions from 'app/actions/UserSearchActions';

const ExternalEmployeesContainer = (props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        //dispatch(UserSearchActions.getExternalEmployeesNames('')); /*No se carga al inicio por rendimiento*/
        //dispatch(UserSearchActions.getExternalEmployeesEmail('')); /*No se carga al inicio por rendimiento*/
        dispatch(UserSearchActions.fetchExternalEmployees({
            limit: 25,
            offset: 0
        }));
    }, []);

    return (
        <div>
            <Grid container direction="row">
                <Grid item xs={12}>
                    <ExternalEmployeesFilterComponent />
                </Grid>
                <Grid item xs={12}>
                    <ExternalEmployeesTableComponent
                        showKardex={props.showKardex}
                        isVisibleKardex={props.isVisibleKardex}
                        setEmployeeId={props.setEmployeeId}
                        setIsExternal = {props.setIsExternal}
                        setExternalUsername={props.setExternalUsername}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default ExternalEmployeesContainer;